import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { BenefitTemplateList } from '@models/BenefitTemplate';
import { API_V1_BASE } from '@config';

export class BenefitTemplateApi {
  static getAll = async () => {
    return await authAxios.get(`${API_V1_BASE}/user/benefit_templates`).then((response) => humps(response.data) as BenefitTemplateList[]);
  };
}
